var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-content py-1 pl-2"},[_vm._v(" © Helpharma S.A 2021 Copyright Todos los derechos reservados ")])}
var staticRenderFns = []

export { render, staticRenderFns }